module.exports = __webpack_public_path__ + "img/plus.2cf35bec.svg";